import React from 'react'
import numeral from 'numeral'
import * as _ from 'recompose'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'

import Form from './../../Form'
import Checkbox from '../../../components/Checkbox'
import { setBidData } from '../../../store/reducers/lots/bid'
const BidForm = ({ error = null, intl, data = {}, lotTitle, minBid, changeField, /*changeCountField,*/ onSubmit, disabled = false, currency, price, help, count, onClick}) => {
if (price && !help){
  data.bidValue = price * count;
  data.bidCount = count;
}
  return (
  <div>
    <h1 className='Signin__title Head'>
      <FormattedMessage id={price ? 'bid.make_purchase' :'bid.make_bid'} />
    </h1>
    <div className='PaymentMethod__title'>{intl.formatMessage({ id: 'bid.lot' })+': '}{lotTitle}
    </div>
    {!price && (
    <div style={{ marginTop: 30, marginBottom:20 }} className='PaymentMethod__title'>
    {intl.formatMessage({ id: 'bid.bid_recommendation' }) + (currency &&(' ' + minBid + ' ' + currency.symbol)) }
    </div>
    )}
    <div className='Rate__form'>
      {!price && (<Form disableBtn disabled={disabled}
        noAutoFocus={true}
        placeholder={intl.formatMessage({ id: 'bid.bid' }) + (currency && (' ' + currency.symbol))}
        onInput={changeField('bidValue')}
        onSubmit={onSubmit}
    value={data.bidValue}
    onClick={onClick}
    />)}
	  
	  {help && (<Form disableBtn disabled={disabled}
        noAutoFocus={disabled}
        placeholder={intl.formatMessage({ id: 'bid.bid' }) + (currency && (' ' + currency.symbol))}
        onInput={changeField('bidValue')}
        onSubmit={onSubmit}
    value={data.bidValue} 
    onClick={onClick}
    />)}
	  
	  {price && !help && (<Form disableBtn disabled={disabled}
        noAutoFocus={disabled}
        onSubmit={onSubmit}
    value={data.bidValue} 
    onClick={onClick}
    />)}

	  {/*price && !help && (<Form disableBtn disabled={disabled}
        noAutoFocus={disabled}
        placeholder={intl.formatMessage({ id: 'bidPayment.count_bay_fixprice' })}
		onInput={changeCountField('bidCount')}
        onSubmit={onSubmit}
	  value={data.bidCount} />)*/}
	  
      {error && <div className='Text'>{error}</div>}
    </div>
	{!price && (
    <div className='Rate__control-body Text'>
      <div className='Rate__control'>
        <Checkbox disabled={disabled} isLight checked={data.isAnonymous || false} onChange={changeField('isAnonymous')} />
      </div>
      <span className='Rate__control-label'>
        <FormattedMessage id='bid.make_bid_anonymously' />
      </span>
    </div>)}
	{!price && (
    <div className='Rate__control-body Text'>
      <div className='Rate__control'>
        <Checkbox disabled={disabled} isLight checked={data.doSubscribe || false} onChange={changeField('doSubscribe')} />
      </div>
      <span className='Rate__control-label'>
        <FormattedMessage id='bid.follow_auction' />
      </span>
    </div>)
	} 
  </div>
  )
}

const mapState = state => ({
  data: R.compose(
    R.evolve({
      bidValue: value => value ? numeral(value).format('0,0') : 0
    }),
    R.pick(['doSubscribe', 'isAnonymous', 'bidValue', 'bidCount']),
    R.pathOr({}, ['lots', 'bid', 'data'])
  )(state)
})

const mapDispatch = (dispatch, { price }) => ({
  changeField: field => value => {
    if (field === 'bidValue')  value = Math.abs(Number(value.replace(/\D/g, '')))
    return dispatch(setBidData(field, value))
  }/*,
  changeCountField: field => value => {
    value = Math.abs(Number(value.replace(/\D/g, '')))
    return dispatch(setBidData(field, value))
  }*/
})

export default _.compose(
  injectIntl,
  connect(mapState, mapDispatch),
  _.lifecycle({
    componentDidMount () {
      if (this.props.isSubscribed) this.props.changeField('doSubscribe')(true)
      if (this.props.price && !this.props.help) this.props.changeField('bidValue')(String(this.props.price))
      //if (!this.props.price) this.props.changeField('bidValue')(String(this.props.minBid))
	  if (this.props.price && !this.props.help) this.props.changeField('bidCount')(String(this.props.count))
    }
  })
)(BidForm)



// WEBPACK FOOTER //
// ./src/components/Lot/BidForm/index.js